import React from "react";
import Link from "../components/Link";
import ReactHtmlParser, { processNodes } from "react-html-parser";

/**
 * General helper functions
 */

export const parseHtml = (html) => {
  // Parse HTML and return a React component
  html = html.replace(/u0026amp;/g, "&");
  return ReactHtmlParser(html);
};

export const transformLink = (node) => {
  // Convert a tags to links that handle routing
  if (node.type === "tag" && node.name === "a") {
    // Replace the admin URL in the link if set
    const link = node.attribs.href;
    return (
      <Link key={link} to={link}>
        {processNodes(node.children, transformLink)}
      </Link>
    );
  }
};

export const transformLists = (node) => {
  // Convert a tags to links that handle routing
  if (node.type === "tag" && node.name === "a") {
    // Replace the admin URL in the link if set
    const link = node.attribs.href;
    return (
      <Link key={link} to={link}>
        {processNodes(node.children, transformLists)}
      </Link>
    );
  }

  if (node.type === "tag" && node.name === "li") {
    return (
      <li>
        {node.content}
        {processNodes(node.children, transformLists)}
      </li>
    );
  }
};

export const asyncForEach = async (array, callback) => {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
};

export const currency = (value) => {
  return `£${(Math.round(value * 100) / 100).toFixed(2)}`;
};

export const encodeUniToHtml = (string = "") => {
  if (!string) return string;
  return string.replace("u00a3", "&pound;");
};

export const isServer = !(typeof window != "undefined" && window.document);

export const isInternalLink = (link) => {
  if (!link) {
    throw new Error("isInternalLink: link is undefined");
  }
  if (!process.env.GATSBY_ADMIN_URL) {
    throw new Error(
      "isInternalLink: process.env.GATSBY_ADMIN_URL is undefined"
    );
  }
  return link.includes(process.env.GATSBY_ADMIN_URL);
};

export const isExternalLink = (link) => {
  return !isInternalLink(link);
};

export const isPdfLink = (link) => {
  return link.includes(".pdf");
};

export const cleanInternalLink = (link) => {
  if (!link) {
    throw new Error("isInternalLink: link is undefined");
  }
  if (!process.env.GATSBY_ADMIN_URL) {
    throw new Error(
      "isInternalLink: process.env.GATSBY_ADMIN_URL is undefined"
    );
  }
  return link.replace(process.env.GATSBY_ADMIN_URL, "/");
};

export const pluralise = (word, count, plural) => {
  if (plural) {
    return count === 1 ? word : plural;
  }
  return count === 1 ? word : `${word}s`;
}

// function to remove all whitespace from a string
export const removeWhitespace = (string) => {
  return string.replace(/\s/g, "");
}

export const formatDate = (date) => {
  const dateObj = new Date(date);
  const day = dateObj.getDate();
  const month = dateObj.toLocaleString("default", { month: "long" });
  const year = dateObj.getFullYear();

  const nthNumber = (number) => {
    if (number > 3 && number < 21) return "th";
    switch (number % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const formattedDate = `${day}${nthNumber(day)} ${month} ${year}`;
  return formattedDate;
}